<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';
import { maskReferenceDate } from './postSaleDate';

defineProps({
  responsibility: { type: Object, default: null },
  requiresLateDetails: { type: Boolean, default: false },
  paymentTiming: { type: String, default: '' },
  interest: { type: String, default: '' },
  penalty: { type: String, default: '' },
  paidOn: { type: String, default: '' },
  finalPaidAmount: { type: String, default: '' },
});

const emit = defineEmits([
  'update-payment-timing',
  'update-interest',
  'update-penalty',
  'updatePaidOn',
]);
const { t } = useI18n();
const updatePaidOn = event =>
  emit('updatePaidOn', maskReferenceDate(event.target.value));
</script>

<template>
  <template v-if="!requiresLateDetails">
    <div>
      <h3 class="font-semibold text-lais-text">
        {{ t('REAL_ESTATE_FINANCE.PAYMENT.FEEDBACK_TITLE') }}
      </h3>
      <p class="mt-1 text-sm text-lais-text-muted">
        {{ t('REAL_ESTATE_FINANCE.PAYMENT.FEEDBACK_DESCRIPTION') }}
      </p>
    </div>
    <fieldset class="flex flex-col gap-3">
      <legend class="text-sm font-semibold text-lais-text">
        {{ t('REAL_ESTATE_FINANCE.PAYMENT.TIMING') }}
      </legend>
      <label
        class="flex cursor-pointer items-start gap-3 text-sm text-lais-text"
      >
        <input
          :checked="paymentTiming === '1'"
          type="radio"
          value="1"
          @change="emit('update-payment-timing', '1')"
        />
        {{ t('REAL_ESTATE_FINANCE.PAYMENT.LATE_OPTION') }}
      </label>
      <label
        class="flex cursor-pointer items-start gap-3 text-sm text-lais-text"
      >
        <input
          :checked="paymentTiming === '2'"
          type="radio"
          value="2"
          @change="emit('update-payment-timing', '2')"
        />
        {{ t('REAL_ESTATE_FINANCE.PAYMENT.ON_TIME_OPTION') }}
      </label>
    </fieldset>
  </template>
  <template v-else>
    <div>
      <h3 class="font-semibold text-lais-text">
        {{ t('REAL_ESTATE_FINANCE.PAYMENT.FEEDBACK_TITLE') }}
      </h3>
      <p class="mt-1 text-sm text-lais-text-muted">
        {{ t('REAL_ESTATE_FINANCE.PAYMENT.LATE_DESCRIPTION') }}
      </p>
    </div>
    <div
      class="grid gap-3 rounded-lais bg-lais-bg-soft p-3 text-sm sm:grid-cols-2"
    >
      <p>
        <span class="block text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.PAYMENT.BOLETO_AMOUNT') }}
        </span>
        <span class="font-semibold text-lais-text">
          {{ responsibility?.valor_pagamento?.amount }}
        </span>
      </p>
      <p>
        <span class="block text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.PAYMENT.DUE_ON') }}
        </span>
        <span class="font-semibold text-lais-text">
          {{ responsibility?.data_validade }}
        </span>
      </p>
    </div>
    <div class="grid gap-4 sm:grid-cols-2">
      <LaisField :label="t('REAL_ESTATE_FINANCE.PAYMENT.INTEREST')" required>
        <input
          :value="interest"
          inputmode="decimal"
          class="min-h-10 rounded-lais border border-lais-border px-3 text-sm"
          @input="emit('update-interest', $event.target.value)"
        />
      </LaisField>
      <LaisField :label="t('REAL_ESTATE_FINANCE.PAYMENT.PENALTY')" required>
        <input
          :value="penalty"
          inputmode="decimal"
          class="min-h-10 rounded-lais border border-lais-border px-3 text-sm"
          @input="emit('update-penalty', $event.target.value)"
        />
      </LaisField>
    </div>
    <div class="grid gap-4 sm:grid-cols-2">
      <LaisField :label="t('REAL_ESTATE_FINANCE.PAYMENT.PAID_ON')" required>
        <input
          :value="paidOn"
          type="text"
          maxlength="10"
          inputmode="numeric"
          :placeholder="t('REAL_ESTATE_FINANCE.PAYMENT.PAID_ON_PLACEHOLDER')"
          class="min-h-10 rounded-lais border border-lais-border px-3 text-sm"
          @input="updatePaidOn"
        />
      </LaisField>
      <div class="rounded-lais bg-lais-bg-soft p-3 text-sm">
        <span class="block text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.PAYMENT.FINAL_AMOUNT') }}
        </span>
        <span class="font-semibold text-lais-text">{{ finalPaidAmount }}</span>
      </div>
    </div>
  </template>
</template>
